export default __webpack_public_path__ + "static/media/selectedLineChartIcon.22e5effe.svg";